import React, { Fragment } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ClientContext } from 'graphql-hooks'

import { WagmiProvider } from "wagmi";
import { QueryClientProvider } from "@tanstack/react-query";
import { ConnectKitProvider } from "connectkit";

import './styles/App.css';
import './styles/index.css'; 

import { config, queryClient } from "./services/web3";
import { graphqlClient } from "./services/graphql";
import Routes from "./routes";

function App() {
  return (
    <Fragment>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <ConnectKitProvider theme="nouns" customTheme={{
              "--ck-border-radius": "30px",
              "--ck-font-family": '"Spartan", sans-serif',
            }} >
            <ClientContext.Provider value={graphqlClient}>
              <Router>
                <Routes />
              </Router>
            </ClientContext.Provider>
          </ConnectKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </Fragment>
  );
}

export default App;
